export default {"src":"/spend-avios/rewards/_next/static/media/avios-logo.a5de62ef.svg","height":41,"width":160,"blurWidth":0,"blurHeight":0};